declare var pm: PmInterface;

/**
 * A single context menu element that can be opened "on demand".
 */
const contextMenu = document.querySelector(
	".context-menu",
) as HTMLElement | null;

const gallery = document.querySelector(".photo-grid") as HTMLElement | null;

// let lastWindowScrollY = window.scrollY;

const initContextMenu = () => {
	const { getClosest } = pm.utils.dom;

	function init() {
		if (!contextMenu) return;

		// window.addEventListener("scroll", onWindowScroll);
		window.addEventListener("keydown", onWindowKeydown);
		document.addEventListener("click", onDocumentClick);
		pm.event.on("context_menu_close", hide);

		if (gallery) {
			gallery.addEventListener("contextmenu", onPhotoRightClick);
		}
	}

	// function onWindowScroll(e: Event) {
	// 	if (!contextMenu) return;
	//
	// 	// When context menu is open, prevent scrolling.
	// 	if (contextMenu.classList.contains("is-open")) {
	// 		e.preventDefault();
	// 		window.scrollTo(0, lastWindowScrollY);
	// 		return;
	// 	} else {
	// 		lastWindowScrollY = window.scrollY;
	// 	}
	// }

	function show(target: HTMLElement, e: MouseEvent) {
		if (!contextMenu) return;
		const bounds = target.getBoundingClientRect();
		const x = e.clientX - bounds.left;
		const y = e.clientY - bounds.top;

		contextMenu.style.left = x + "px";
		contextMenu.style.top = y + "px";

		contextMenu.classList.add("is-open");
	}

	function hide() {
		if (!contextMenu) return;
		if (!contextMenu.classList.contains("is-open")) return;
		emitPreclosingEvent();
		contextMenu.classList.remove("is-open");
		document.body.appendChild(contextMenu);
	}

	function hideByClick(e: MouseEvent) {
		const target = e.target as HTMLElement;

		if (!target.classList.contains("close-on-click")) {
			if (getClosest(target, ".context-menu")) {
				return;
			}
		}

		hide();
	}

	function emitPreclosingEvent() {
		pm.event.emit("before_context_menu_close", {});
	}

	function onWindowKeydown(e: KeyboardEvent) {
		const key = e.key.toLowerCase();

		if (key === "escape" || key === "esc") {
			hide();
		}
	}

	function onDocumentClick(e: MouseEvent) {
		if (!getClosest(e.target as HTMLElement, ".context-menu")) {
			hideByClick(e);
			return;
		}

		if (getClosest(e.target as HTMLElement, ".close-on-click")) {
			hideByClick(e);
			return;
		}
	}

	function onPhotoRightClick(e: MouseEvent) {
		e.preventDefault();

		let photo = getClosest(
			e.target as HTMLElement,
			".has-context-menu",
		) as HTMLImageElement;

		if (!photo) return;

		const photoWrapper = photo!.parentNode as HTMLElement;
		if (!photoWrapper) return;

		const photoId = photoWrapper.dataset.photoId;

		contextMenu!.dataset.photoId = photoId;

		const gridItem = photoWrapper.parentNode as HTMLLIElement;
		if (!gridItem) return;

		// Move the contextMenu element to be inside the grid item.
		gridItem.appendChild(contextMenu!);

		pm.event.emit("before_context_menu_open", {
			photoId: photoId,
			photo: photo,
			photoWrapper: photoWrapper,
		});

		show(gridItem, e);
	}

	init();
};

export default initContextMenu;
